import TableFiltersContextProvider from "@/common/contexts/Table.context";
import { guardCheck } from "@/common/utils";
import { Loader } from "@/components";
import DocumentsMe from "@/pages/DocumentsMe.page";
import { lazy, Suspense } from "react";
import { redirect } from "react-router";

const Documents = lazy(() => import("@/pages/Documents.page"));

const documentsRoute = [
  {
    path: "documents",
    loader: async ({ request }: { request: Request }) => {
      const isAllowed = guardCheck(request, "documents/airx");
      if (!isAllowed) {
        throw redirect("/404");
      }
      return request;
    },
    element: (
      <Suspense fallback={<Loader />}>
        <TableFiltersContextProvider>
          <Documents />
        </TableFiltersContextProvider>
      </Suspense>
    ),
  },
  {
    path: "documents/me",
    loader: async ({ request }: { request: Request }) => {
      const isAllowed = guardCheck(request, "documents/customer/vendor");
      if (!isAllowed) {
        throw redirect("/404");
      }
      return request;
    },
    element: (
      <Suspense fallback={<Loader />}>
        <TableFiltersContextProvider>
          <DocumentsMe />
        </TableFiltersContextProvider>
      </Suspense>
    ),
  },
];

export default documentsRoute;
